import type { FieldError } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import { AgesTour } from 'entities/tour/types'

import { AppIcon } from 'shared/ui/app-icon'
import { AllIcons } from 'shared/ui/app-icon/types'

import styles from './styles.module.scss'

const MAX_COUNT = 9

interface Props {
  maxNumber?: number
  minNumber?: number
  onChange: (count: number) => void
  title?: string
  subTitle?: string
  value?: number
  alignCenter?: boolean
  ageType?: string
  variant?: 'circle' | 'square'
  titleClass?: string
  error?: FieldError
}

export const ButtonInputValue = ({
  title,
  subTitle,
  value = 0,
  onChange,
  minNumber = 0,
  maxNumber = MAX_COUNT,
  alignCenter,
  ageType,
  variant = 'circle',
  titleClass,
  error,
}: Props) => {
  const { t } = useTranslation()

  const onChangeHandler = (num: number) => {
    if (minNumber <= num && maxNumber >= num) {
      onChange(num)
    }
  }

  const showInfo = value >= maxNumber && ageType === AgesTour.adults.key

  return (
    <div className={styles.box}>
      <div
        className={clsx(styles.container, alignCenter && styles.alignCenter)}
      >
        <div className={styles.left}>
          <p className={clsx(titleClass, styles.title, styles[variant])}>
            {title}
          </p>

          {subTitle && <span className={styles.subtitle}>{subTitle}</span>}
        </div>

        <div className={styles.right}>
          <div
            className={clsx(styles.button, styles[variant])}
            onClick={() => onChangeHandler(value - 1)}
          >
            <AppIcon
              id={AllIcons.MINUS_BOLD}
              height={16}
              width={16}
              className={clsx(
                value <= minNumber ? styles.inActive : styles.icon,
              )}
            />
          </div>
          <div className={styles.count}>{value}</div>
          <div
            className={clsx(styles.button, styles[variant])}
            onClick={() => onChangeHandler(value + 1)}
          >
            <AppIcon
              id={AllIcons.PLUS_BOLD}
              height={16}
              width={16}
              className={clsx(
                value >= maxNumber ? styles.inActive : styles.icon,
              )}
            />
          </div>
        </div>
      </div>

      {showInfo && (
        <div className={styles.info}>
          {t('tours_block.max_adults', { count: maxNumber })}
        </div>
      )}

      {error?.message && <p className={styles.errorText}>{error.message}</p>}
    </div>
  )
}
